
























































import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { courseItem, saveList } from '@/api/res'
import { Tooltip, Modal, message } from 'ant-design-vue'
import { iconMap } from '@/util/resMap'

@Component
export default class CourseDetail extends ViewBase {
  @Prop({ type: Number, default: 0 }) id!: number
  @Prop({ type: Number, default: 0 }) type!: number

  item: any = {}
  lang: any = {}
  imgurl = ''
  resList: any[] = []
  saveListLoading: boolean = false
  hasAddCourse: boolean = false
  iconMap = iconMap


  get isMyCourse() {
    return String(this.$route.params.type) === '1'
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get afterNum() {
    return this.item.res_list ? 3 - (this.item.res_list.length % 3) : 0
  }

  created() {

    this.lang = this.i18n.VCourse
    const lang: any = this.lang
    this.fetch()
  }
  async fetch() {
    const query: any = {
      id: this.id,
      type: this.type + ''
    }

    try {
      const { data } = await courseItem(query)
      this.item = data
      this.imgurl = data.banner
      this.resList = data.res_list
    } catch (ex) {
      this.handleError(ex)
    }
  }
  goCourse() {
    const resList = (this.resList || []).map(({ rid, title, res_type }) => ({
      id: rid,
      title,
      res_type
    }))
    // console.log(this.item)

    const type = 0
    // 0 云端课程 1本地课程
    const all = Object.assign({}, this.item, { alltype: type })

    // this.$store.commit('setplayALL', all)

    this.$store.commit('setplayALL', this.item)
    this.$store.commit('setPlayList', resList)
    this.$router.push({
      name: 'playIndex',
      params: {
        id: this.id + ''
      }
    })
  }
  editCourse() {
    const resList = (this.resList || []).map(({ rid, title, res_type }) => ({
      id: rid,
      title,
      res_type
    }))
    this.$store.commit('setPlayList', resList)
    this.$router.push({ name: 'courseEdit', params: { id: this.id + '' } })
  }
  async saveListclick() {
    const ids = this.resList.map(it => it.rid)

    try {
      const pdata = {
        title: this.item.title,
        resource_ids: ids.join(',')
      }
      await saveList(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
    } catch (ex) {
      this.handleError(ex)
    }
    // this.$store.commit('setPlayList', resList)
    //  this.$router.push({ name: 'courseEdit', params: { id: this.id + '' } })
  }

  async addCourse() {
    if (this.hasAddCourse) {
      return
    }
    if (this.saveListLoading) {
      return
    }

    const resList = (this.resList || [])
    const ids = {}
    resList.map((it: any) => {
        const tmp: any = {}
        tmp[it.rid] = it.desc
        Object.assign(ids, tmp)
    })

    const title = this.item.title
    this.saveListLoading = true
    try {
      const pdata = {
        title,
        resource_ids: ids
      }
      await saveList(pdata)
      message.success(this.lang.addCourseSuccess)
      this.hasAddCourse = true
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.saveListLoading = false
    }
  }

  // 点击事件,我的课程：点击直接进入课堂
  itemClick(it: any) {
    const detailRoute: any = {
      name: 'resourceDetail',
      params: { id: it.rid, type: 1 }
    }
    this.$router.push(detailRoute)
  }
}
